import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AccountType } from '../models/account-type.enum';
import { AuthService } from '../services/auth.service';

function evaluateRoleAccess(
  allowedRoles: AccountType[],
): boolean | ReturnType<Router['createUrlTree']> {
  const authService = inject(AuthService);
  const router = inject(Router);

  const role = authService.resolveAccountType();

  if (!role) {
    return router.createUrlTree(['/auth/login']);
  }

  if (allowedRoles.includes(role)) {
    return true;
  }

  return router.createUrlTree(['/auth/access-denied']);
}

/** Restricts routes to one or more {@link AccountType} values. */
export function roleGuard(...allowedRoles: AccountType[]): CanActivateFn {
  return () => evaluateRoleAccess(allowedRoles);
}

/** Redirects bare `/` or legacy `/dashboard` to the role dashboard. */
export const roleHomeRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const home = authService.getRoleHomePath();

  if (home === '/auth/login') {
    return router.createUrlTree(['/auth/login']);
  }

  return router.parseUrl(home);
};
